import React, { useState, useEffect } from 'react';
import './EmpresaA';
import TableContainer from './general/TableContainer';
import { getAllUsers, fetchCompanies, deleteUser } from './general/api'; // Importamos deleteUser
import { useDispatch, useSelector } from 'react-redux';
import { setCompanys, setMenu } from '../actions/index';
import UsuarioUpd from './UsuarioUpd';

const UsuarioA = () => {
  const dispatch = useDispatch();
  const companys = useSelector((state) => state.companys.companys); // Empresas desde Redux
  const menu = useSelector((state) => state.menu.menu); // Menú actual
  const [selectedCompanyId, setSelectedCompanyId] = useState(null); // Empresa seleccionada
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null); // Usuario seleccionado para actualizar

  // Obtener empresas si no existen en el estado
  useEffect(() => {
    const fetchCompaniesData = async () => {
      if (!companys || companys.length === 0) {
        setLoading(true);
        try {
          const companiesData = await fetchCompanies();
          dispatch(setCompanys(companiesData)); // Almacenar en Redux
        } catch (err) {
          console.error(err);
          setError('Error al obtener las empresas');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCompaniesData();
  }, [companys, dispatch]);

  // Obtener usuarios cuando se selecciona una empresa
  useEffect(() => {
    const fetchUsersData = async () => {
      if (selectedCompanyId) {
        setLoading(true);
        setError(null);
        try {
          const usersData = await getAllUsers(selectedCompanyId);
          if (Array.isArray(usersData)) {
            setUsers(usersData);
          } else {
            setError('Formato de datos inválido');
          }
        } catch (err) {
          console.error(err);
          setError(err.message);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUsersData();
  }, [selectedCompanyId]);

  // Manejo de selección de empresa
  const handleCompanySelect = (e) => {
    setSelectedCompanyId(e.target.value);
    setUsers([]); // Limpiar la lista de usuarios mientras carga
  };

  // Manejo de botones (agregar/editar/eliminar usuarios)
  const handleButtonClick = async (button) => {
    if (button === 'add') {
      dispatch(setMenu('usuarioNue')); // Cambiar al formulario de nuevo usuario
    } else if (button === 'edit') {
      if (selectedUser) {
        dispatch(setMenu('usuarioUpd')); // Cambiar al formulario de edición de usuario
      } else {
        alert('Por favor selecciona un usuario antes de editar');
      }
    } else if (button === 'delete') {
      if (selectedUser[0]) {
        const confirmDelete = window.confirm(
          `¿Estás seguro de que deseas eliminar al usuario "${selectedUser[0].Name_User}"? Esta acción no se puede deshacer.`
        );
        if (confirmDelete) {
          try {
            await deleteUser(selectedUser[0].Id_User); // Llamar a la API para eliminar el usuario
            alert('Usuario eliminado con éxito.');
            // Recargar lista de usuarios tras la eliminación
            const updatedUsers = await getAllUsers(selectedCompanyId);
            setUsers(updatedUsers);
          } catch (err) {
            console.error('Error al eliminar el usuario:', err);
            alert('Ocurrió un error al eliminar el usuario.');
          }
        }
      } else {
        alert('Por favor selecciona un usuario antes de eliminar');
      }
    }
  };

  const onRowClick = (row) => {
    setSelectedUser(row); // Guardar usuario seleccionado
  };

  const onRowDoubleClick = (row) => {
    setSelectedUser([row]); // Guardar usuario seleccionado
    dispatch(setMenu('usuarioUpd')); // Cambiar al formulario de edición de usuario
  };

  return (
    <div className="empresaA">
      <h2>Gestión de Usuarios</h2>

      {menu === 'usuarioAct' && (
        <>
          {loading && <p>Cargando datos...</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}

          {!loading && companys && companys.length > 0 ? (
            <>
              <div className="empresaA__select">
                <div>
                  <label htmlFor="companySelect">Seleccione una Empresa:</label>
                </div>
                <select
                  id="companySelect"
                  onChange={handleCompanySelect}
                  value={selectedCompanyId || ''}
                >
                  <option value="" disabled>Seleccione una empresa</option>
                  {companys.map((company) => (
                    <option key={company.Id_Empresa} value={company.Id_Empresa}>
                      {company.Name_Emp}
                    </option>
                  ))}
                </select>
              </div>

              {selectedCompanyId && (
                <TableContainer
                  title="Usuarios de la Empresa"
                  data={users}
                  columns={[
                    { header: 'ID', field: 'Id_User', visible: false },
                    { header: 'Nombre', field: 'Name_User' },
                    { header: 'Identificación', field: 'Cc_User' },
                    { header: 'Nivel de Acceso', field: 'Id_Access' },
                  ]}
                  handleButtonClick={handleButtonClick}
                  onRowClick={onRowClick}
                  onRowDoubleClick={onRowDoubleClick}
                  buttonList={['add', 'edit', 'delete']}
                  loading={loading}
                  error={error}
                  showPieChart={true}
                />
              )}
            </>
          ) : (
            <p>No hay empresas disponibles. Intenta recargar.</p>
          )}
        </>
      )}

      {menu === 'usuarioUpd' && selectedUser && (
        <UsuarioUpd userData={selectedUser} />
      )}
    </div>
  );
};

export default UsuarioA;
